import React, { useEffect } from 'react';
import {View, Text, StyleSheet, AccessibilityInfo} from 'react-native';
import {useTranslation} from 'react-i18next';
import type {Grade} from '../models';
import {GRADE_COLORS} from '../models/Product';

interface GradeDisplayProps {
  grade: Grade;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
  announceOnMount?: boolean;
}

const GradeDisplay: React.FC<GradeDisplayProps> = ({
  grade,
  size = 'medium',
  showLabel = false,
  announceOnMount = false,
}) => {
  const {t} = useTranslation();
  const color = GRADE_COLORS[grade];

  // Afmetingen bepalen (klein, gemiddeld, groot)
  const sizeStyles = {
    small: {
      container: stijlen.containerSmall,
      text: stijlen.textSmall,
    },
    medium: {
      container: stijlen.containerMedium,
      text: stijlen.textMedium,
    },
    large: {
      container: stijlen.containerLarge,
      text: stijlen.textLarge,
    },
  };

  const currentSize = sizeStyles[size];

  // Voor blinden en slechtzienden even voorlezen welk cijfer het is
  useEffect(() => {
    if (announceOnMount) {
      const message = t('accessibility.gradeAnnouncement', { grade });
      AccessibilityInfo.announceForAccessibility(message);
    }
  }, [announceOnMount, grade, t]);

  return (
    <View style={stijlen.wrapper}>
      <View style={[stijlen.container, currentSize.container, {backgroundColor: color}]}>
        <Text style={[stijlen.text, currentSize.text]}>{grade}</Text>
      </View>
      {showLabel && (
        <Text style={stijlen.label}>{t('product.planetaryImpactScore') || 'Planeet Impact Score'}</Text>
      )}
    </View>
  );
};

const stijlen = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
  },
  container: {
    borderRadius: 1000,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 3,
    elevation: 3,
  },
  containerSmall: {
    width: 40,
    height: 40,
  },
  containerMedium: {
    width: 60,
    height: 60,
  },
  containerLarge: {
    width: 100,
    height: 100,
  },
  text: {
    color: '#FFFFFF',
    fontWeight: 'bold',
  },
  textSmall: {
    fontSize: 16,
  },
  textMedium: {
    fontSize: 24,
  },
  textLarge: {
    fontSize: 36,
  },
  label: {
    marginTop: 8,
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
});

export default GradeDisplay;
